/**
 * @desc 立即同步邮件
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(mailAccountCode: string | number, options?: any) {
  return updateResponse(
    http(URL + `/mail/mailAccount/sync/${mailAccountCode}`, {
      method: "POST",

      ...options,
    }),
  );
}
